export const apiEndpoints=()=> {
    let urls = {};

    urls.SIGNUP_API = 'userApi/user/v1/signup_user';
    urls.TOOLBAR_POINT =  'jodotoolbar';
    urls.GET_PASSWOED_KEY = "LoginWebService/";
    urls.CRUD_API_SMS='smsApi/sms/';
    urls.CRUD_API_EMAIL='emailApi/email/';
    urls.CRUD_API_DOC='documentApi/document/';
    urls.CRUD_API_AGENTTHRESHHOLD='agentthreshholdApi/agent/';
    urls.CRUD_API_VOICERECORDING='recordingApi/recording/';
    urls.CRUD_API_AUTORESPONSE='autoresponseApi/autoresponse/';
    urls.CRUD_API_DISPOSITION='dispositionApi/disposition';
    urls.CRUD_API_TIME='timeApi/time';
    urls.CRUD_API_SKILL='skillsetApi/skill/';
    urls.CRUD_API_WEBHOOK='webhookApi/webhook';
    urls.CRUD_API_PROCESS='processApi/process/';
    urls.CRUD_API_USERS='userApi/user/';
    urls.CRUD_API_SCRIPT='formscriptApi/script/';
    urls.CRUD_API_MASTER = "masterApi/v1/master/";
    urls.UPLOAD_API="uploadApi/uploadfile"
    urls.UPLOAD_IMG_API = "uploadApi/uploadBase64String/"
    urls.CRUD_API_REPORT="reportApi/report"
    urls.CRUD_API_ORG = "organisationApi/org/"
    urls.GET_USER_API="userApi/user/get_user"
    urls.GET_USER_BY_LOGINID = "userApi/user/get_email/"
    urls.TEAM_API = "/dataTemplateApi/data_template"
    urls.GET_TEAM_TEMPLATE = "/teamApi/get_team"
    urls.GET_SCRIPT_LIST = "formscriptApi/script/type/"
    urls.GET_PASSWOED_KEY = "LoginWebService/"
	return urls;
}



